<script setup>
import {inject, onMounted, ref} from 'vue'
import axios from 'axios'
const contentData = inject('contentData')

const sessions = ref([])

onMounted(async () => {
    await getSessions('api/sessions')
})
const backEndURL = process.env.VUE_APP_BACKEND_URL

const getSessions = async url => {
    try {
        const res = await axios.get(`${backEndURL}/${url}`)
        sessions.value = res.data
    } catch (err) {
        console.error(err)
    }
}
</script>

<template>
    <section class="bg-white bg-contain bg-center bg-no-repeat py-10 sm:py-16" id="submission">
        <div class="container mx-auto max-w-4xl px-4 sm:px-6">
            <div class="mx-auto max-w-3xl text-center">
                <h1 class="font-heading mb-5 mt-2 text-3xl sm:mb-6 sm:text-4xl">{{ $t('submission.title') }}</h1>
                <div class="rounded-lg border border-slate-200 bg-slate-50 px-5 py-5 text-left shadow-sm sm:px-6">
                    <b class="block text-sm uppercase tracking-[0.12em] text-slate-700">{{ $t('submission.deadline') }}</b>
                    <div class="mt-4 space-y-2 text-base leading-7 text-slate-800 sm:text-lg">
                        <p><span class="font-semibold">Workshop:</span> 31 January 2024</p>
                        <p><span class="font-semibold">Contributed Talk:</span> 30 April 2024</p>
                        <p><span class="font-semibold">Posters:</span> 10 May 2024</p>
                    </div>
                </div>
            </div>

            <div class="mx-auto mt-8 max-w-3xl">
                <p class="text-left text-base leading-7 text-slate-800 sm:text-justify sm:text-lg sm:leading-8">
                    NEXUS invited to submit abstracts for workshops, contributed talks, and/or posters.
                </p>
                <p class="mt-6 text-left text-base leading-7 text-slate-800 sm:text-justify sm:text-lg sm:leading-8">
                    Submissions for contributed talks were welcome in all areas related to the 4 session
                    topics of the conference:
                </p>

                <div class="mx-auto mt-5 max-w-3xl rounded-lg border-l-4 border-teal-600 bg-teal-50 px-5 py-4 text-left text-base leading-7 text-slate-800 sm:px-6 sm:text-lg sm:leading-8">
                    <ul class="ml-5 list-disc space-y-1">
                        <li v-for="item in sessions.filter(s => s.display)">{{ item.name }}</li>
                    </ul>
                </div>

                <p class="mt-6 text-left text-base leading-7 text-slate-800 sm:text-justify sm:text-lg sm:leading-8">
                    The call has ended. Notifications of acceptance or rejection will be sent by June 7th
                    2024.
                </p>
            </div>

            <!--            <div class="max-w-3xl mx-auto text-center mt-10">-->
            <!--                <a-->
            <!--                    target="_blank"-->
            <!--                    class="inline-block py-4 px-6 text-center font-heading font-medium text-base text-white bg-blue-800 hover:bg-green-600 rounded-sm transition duration-200"-->
            <!--                    href="https://ethzurich.eventsair.com/pht-2024/submission">-->
            <!--                    {{ $t('submission.submitBtn') }}-->
            <!--                </a>-->
            <!--            </div>-->
        </div>
    </section>
</template>

<style scoped></style>
